<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler" :submit-url="`${getGetters('ageUrl')}/DingBiao/ZbHxrGs/add.json`">
            <el-form-item label="招标项目" class="table-full-row">
                {{model.zbprocode}}--{{model.zbproname}}
            </el-form-item>

            <el-form-item label="标段名称"  prop="bdname" :rules="newRule('标段名称', 'required')">
                {{form.bdname}}
            </el-form-item>
            <el-form-item label="标段编码"  prop="bdcode" :rules="newRule('标段编码', 'required')">
                {{form.bdcode}}
            </el-form-item>
            <el-form-item label="公示名称"  prop="gsname" :rules="newRule('公示名称', 'required')">
                <el-input v-model="form.gsname"></el-input>
            </el-form-item>
            <el-form-item label="公示类型"  prop="gstypecode" :rules="newRule('公示名称', 'required')">
                <el-select v-model="form.gstypecode" placeholder="请选择公示类型" @change="getgstype">
                    <el-option v-for="item in gstypeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="公示开始时间"  prop="gsstarttime" :rules="newRule('公示开始时间', 'required')">
                <el-date-picker
                    v-model="form.gsstarttime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="datePickerOptions"
                    default-time="00:00:00"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="公示结束时间"  prop="gsendtime" :rules="newRule('公示结束时间', 'required')">
                <el-date-picker
                    v-model="form.gsendtime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="pickerOptionsend"
                    default-time="00:00:00"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="招标限价（万元）"  prop="zbxj" :rules="newRule('招标限价（万元）', 'required')" v-if="model.jt">
                <el-input v-model="form.zbxj"></el-input>
            </el-form-item>
            <el-form-item label="公示内容文本" prop="gscontent" :rules="newRule('公示内容文本', 'required')" class="table-full-row">
                <ueditor v-model="form.gscontent" />
            </el-form-item>
        
            <el-form-item label="附件" class="table-full-row">
                <my-tag type="danger">文件类型：jpg、pdf；单个文件大小1.5mb；</my-tag>
                <my-tag type="danger" style="margin-bottom:10px;" v-if="form.gstypecode==='2'"> 
                    <div class="reason">
                        特别提示：1、请按照“更正公告的格式”认真填写，加盖单位公章，并扫描上传。更正公告一经发布不能修改，请仔细检查。<a href="http://123.182.227.105:9999/tool/招标、中标更正.rar">（点此下载“更正公告格式”）</a>
                    </div>
                    <div class="reason" style="text-indent:5em">
                        2、请严格按照相关招投标法律、法规要求进行更正。
                    </div>
                </my-tag>
                <my-upload  
                    :file-guid="form.fileguid|| ''" 
                    file-type=".jpg,.pdf" 
                    :file-size="1.5">
                </my-upload>
            </el-form-item>
            
            <template slot="btn" slot-scope="scope">
                <el-button @click="saveHandler(1, scope.submitHandler)" type="primary" icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button @click="saveHandler(0, scope.submitHandler)" type="warning" icon="el-icon-remove-outline">
                    暂存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
        
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN],
    data() {
        var that = this;
        return{
            form:{
                qbtbdw:'',
                isXt:this.getQuery('isXt')||'',
            },
            model:{},
            bdList:[],
            dwname:'',
            gstypeList:[
                { value:'2',label:'更正'},
            ],
            // 开始时间
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },
            //结束时间
            pickerOptionsend: {
                // disabledDate(time) { //结束时间的禁用
                //     return time.getTime() <new Date(that.form.gsstarttime).getTime()+8.64e7+8.64e7;
                // }
                disabledDate(time) { //结束时间的禁用
                    var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(that.form.gsstarttime)
                    return time.getTime() < new Date(newDate[0] + ' 00:00').getTime() + 8.64e7 + 8.64e7;
                }
            },

        }
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {
        
        getgstype(){
            var that = this
            that.gstypeList.forEach(function(item){
                if(item.value===that.form.gstypecode){
                    that.form.gstypename = item.label
                }
            })
        },
        // 保存
        saveHandler(type, cb){
            this.form.shbj = type;
            this.form.isXt = this.getQuery('isXt')
            cb && cb();
        },
    },
    created() {
        var that = this
        var data = {}
        if(this.getQuery('id')){
            // 编辑
            data = { procode: this.getQuery('procode'),id:this.getQuery('id'),isXt:this.getQuery('isXt'), }
        }else{
            // 添加
            data = { procode: this.getQuery('procode'),bdcode:this.getQuery('bdcode'),isXt:this.getQuery('isXt'), }
        }
        this.jspInit(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/bgGsEdit.json`, data, data => {
            that.model = data
            that.form = data.model
            that.form.fileguid = data.fileguid
            that.getgstype()
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
